import { RefreshCw, Plus } from 'lucide-react';

interface PreviousSession {
  id: string;
  current_phase: string;
  updated_at: string;
}

interface SessionRecoveryProps {
  sessions: PreviousSession[];
  onResume: (sessionId: string) => void;
  onNewSession: () => void;
}

export default function SessionRecovery({ sessions, onResume, onNewSession }: SessionRecoveryProps) {
  const activeSessions = sessions.filter((s) => s.current_phase !== 'export');

  if (activeSessions.length === 0) return null;

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-6">
      <h3 className="text-sm font-semibold text-blue-800 mb-1">Resume Your Session?</h3>
      <p className="text-xs text-blue-600 mb-4">
        You have {activeSessions.length} coaching session{activeSessions.length !== 1 ? 's' : ''} in progress.
      </p>

      <div className="space-y-2 mb-4">
        {activeSessions.slice(0, 3).map((session) => (
          <button
            key={session.id}
            onClick={() => onResume(session.id)}
            className="w-full flex items-center gap-3 px-4 py-3 bg-white rounded-lg border border-blue-200 hover:border-blue-400 transition-colors text-left"
          >
            <RefreshCw className="w-4 h-4 text-blue-500 shrink-0" />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-800 capitalize">
                Phase: {session.current_phase}
              </p>
              <p className="text-xs text-gray-500">
                Last active: {new Date(session.updated_at).toLocaleDateString()}
              </p>
            </div>
          </button>
        ))}
      </div>

      <button
        onClick={onNewSession}
        className="flex items-center gap-2 text-sm text-blue-600 hover:text-blue-800 font-medium"
      >
        <Plus className="w-4 h-4" />
        Start a new session instead
      </button>
    </div>
  );
}
